var map = {
	"./1.webp": 481,
	"./10.webp": 482,
	"./11.webp": 483,
	"./2.webp": 484,
	"./3.webp": 485,
	"./4.webp": 486,
	"./5.webp": 487,
	"./6.webp": 488,
	"./7.webp": 489,
	"./8.webp": 490,
	"./9.webp": 491,
	"./fl88.webp": 492,
	"./fl88_o.webp": 493,
	"./gamelist.webp": 494,
	"./ganimal.webp": 495,
	"./gbattle.webp": 496,
	"./gchess.webp": 497,
	"./gegame.webp": 498,
	"./gfish.webp": 499,
	"./glive.webp": 500,
	"./glotto.webp": 501,
	"./gmultiple.webp": 502,
	"./gsport.webp": 503,
	"./knowhow-1.webp": 504,
	"./knowhow-2.webp": 505,
	"./knowhow-3.webp": 506,
	"./knowhow-4.webp": 507
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 480;